// extracted by mini-css-extract-plugin
export default {"input":"Input_input__+xIWo","textarea":"Input_textarea__Qbg2l"};